import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  budget: Yup.string(),
  description: Yup.string().max(1000),
  domain: Yup.string(),
  modules: Yup.array(),
  stage: Yup.array(),
  time_period: Yup.string(),
  type: Yup.string(),
  name: Yup.string()
    .min(2, 'Must be at least 2 characters long')
    .max(100, 'To long')
    .required('Name is required')
    .matches(/^[\p{L}\s'\-’]+$/u, 'Only letters and hyphens allowed'),
  email: Yup.string()
    .email('Enter a valid email address')
    .required('Email is required')
    .matches(
      /^[a-zA-Z0-9_%+-][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Enter a valid email address',
    ),
  // files: Yup.array().of(
  //   Yup.mixed().test('fileType', 'File must be provided', (value) => value)
  // ),
});
export default validationSchema;
